/** True for single-article public GET paths like /api/articles/my-slug (not list queries). */
export function isArticleDetailPublicPath(path: string): boolean {
  return /^\/api\/articles\/[^/?]+$/.test(path);
}
